import { Checkbox } from 'antd';
import React from 'react';
import styles from './COCheckbox.module.scss';
import { Field, FieldProps, FormikValues, useFormikContext } from 'formik';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

export interface CheckboxInputProps {
  children?: string;
  name?: string;
  disabled?: boolean;
  onChange?: (e: CheckboxChangeEvent) => void;
  label?: JSX.Element;
}

const COCheckbox: React.FC<CheckboxInputProps> = ({
  disabled,
  onChange,
  label,
  name,
}: CheckboxInputProps) => {
  const { setFieldValue } = useFormikContext();

  const handleCheckBoxChange = (e: CheckboxChangeEvent) => {
    const { target } = e;
    if (name) {
      setFieldValue(name, target?.checked);
      onChange?.(e);
    }
  };
  return (
    <div className={styles.checkboxContainer}>
      <Field name={name}>
        {({ field }: FieldProps<FormikValues>) => {
          return (
            <Checkbox
              {...field}
              disabled={disabled}
              onChange={handleCheckBoxChange}
              checked={Boolean(field.value)}>
              {label}
            </Checkbox>
          );
        }}
      </Field>
    </div>
  );
};

export default COCheckbox;
